import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getMyQueueList,
  updateConfig,
} from "../../../store/slices/Packings/packingsSlice";
// import { startTimer } from "../api"; // Timer feature disabled
import { toast } from "react-toastify";

const usePacking = () => {
  const packingState = useSelector((state) => state.packings);
  const states = packingState?.myQueueList;
  const [showDetail, setShowDetail] = useState(false);
  const [detailId, setDetailId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [pendingPage, setPendingPage] = useState(1);
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const dispatch = useDispatch();
  const slug = sessionStorage?.getItem("slug");
  const [clickedCardId, setClickedCardId] = useState(null);

  useEffect(() => {
    if (packingState?.search != "") {
      dispatch(
        updateConfig((state) => {
          state.search = "";
        }),
      );
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      getMyQueueList({
        page: pendingPage,
        per_page: 10,
        process_slug: slug,
        search: packingState?.search,
      }),
    );
    //eslint-disable-next-line
  }, [pendingPage, slug]);

  // Timer feature disabled
  // const startTimerPacking = (item) => {
  //   setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item,
  //     process_slug: slug,
  //   };
  //   startTimer(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleChange = (id) => {
    setActiveCard({ id: id, key: "Pending" });
    // startTimerPacking(id); // Timer feature disabled
    setDetailId(id);
    setShowDetail(true);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.selectedId = id;
        state.table.currentPage = 1;
        state.clear = true;
      }),
    );
    const timmerId = setTimeout(() => {
      dispatch(updateConfig((state) => (state.clear = false)));
      clearTimeout(timmerId);
    }, 100);
  };

  const handleInputSearch = (e) => {
    dispatch(updateConfig((state) => (state.search = e?.target?.value)));
  };

  const handleSearch = () => {
    const searchValue = packingState?.search;
    dispatch(
      updateConfig((state) => {
        state.myQueueList.Pending = [];
        state.search = searchValue;
      }),
    );
    dispatch(
      getMyQueueList({
        search: searchValue,
        process_slug: slug,
        page: 1,
      }),
    );
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      packingState?.myQueueList?.Pending?.length !==
        packingState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
    }
  };

  return {
    packingState,
    states,
    showDetail,
    isLoading,
    totalLength: {
      Pending: packingState.total.Pending,
    },
    apiStatus: {
      Pending: packingState.queueStatus,
    },
    activeCard,
    itemId: packingState.selectedPacking?.[0]?.[0],
    detailId,
    handleSearch,
    handleInputSearch,
    setIsLoading,
    handleChange,
    handleLoadMore,
  };
};

export default usePacking;
